import http from './http';

export default {
  all() {
    return http().get(`/v1/snippets`);
  },
  get(id) {
    return http().get(`/v1/snippets/${id}`);
  },
  create(data) {
    return http().post(`/v1/snippets`, data);
  },
  clone(id) {
    return http().post(`/v1/snippets/${id}/clone`);
  },
  update(data) {
    return http().put(`/v1/snippets/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/snippets/${id}`);
  },
}
